var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIconRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.9741,
    cy: 10,
    rx: 9.9741,
    ry: 10,
    fill: "#FF6060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9718 11.8486H9.10561L8.81166 5.04688H11.2658L10.9718 11.8486ZM8.7433 13.9678C8.7433 13.6305 8.86407 13.3548 9.10561 13.1406C9.3517 12.9219 9.65704 12.8125 10.0216 12.8125C10.3862 12.8125 10.6893 12.9219 10.9308 13.1406C11.1769 13.3548 11.2999 13.6305 11.2999 13.9678C11.2999 14.305 11.1769 14.583 10.9308 14.8018C10.6893 15.016 10.3862 15.123 10.0216 15.123C9.65704 15.123 9.3517 15.016 9.10561 14.8018C8.86407 14.583 8.7433 14.305 8.7433 13.9678Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconRed);
export default __webpack_public_path__ + "static/media/alert-icon-red.80d2af98.svg";
export { ForwardRef as ReactComponent };